import React, { FC, CSSProperties } from 'react';

interface WrapperProps {
    children: React.ReactNode;
}


export const ContentWrapper:FC<WrapperProps> = ({ children, ...props }):JSX.Element => {
    // Defines area and padding of content
    return (
        <div className="content-wrapper p4" {...props}>
            {children}
        </div>
    )
}


interface ExtendedWrapperProps extends WrapperProps {
    className?: string;
    bg?: 'bg-primary' | 'bg-secondary' | 'bg-gray' | 'bg-transparent' | 'bg-success' | 'bg-warning' | 'bg-danger' | 'bg-black';
    r?: 'r15' | 'r10' | 'r5' | 'r0';
    p?: 'p4' | 'p3' | 'p2' | 'p1' | 'p0' | 'p-v-0' | 'p-v-1' | 'p-v-2' | 'p-v-3' | 'p-v-4';
    style?: CSSProperties;
}


export const BoxWrapper:FC<ExtendedWrapperProps> = ({ 
    children,
    className='', 
    bg='bg-transparent',
    r='r0', 
    p='p2',
    style,
    ...props 
}):JSX.Element => {
    const classValue = (`${bg} ${r} ${p}` + ' ' + className).trim()
    return (
        <div className={classValue} style={style} {...props}>
            {children}
        </div>
    )
}


interface ConditionalWrapperPrors {
    children: React.ReactNode;
    condition: boolean;
}

export const ConditionalWrapper:FC<ConditionalWrapperPrors> = ({ condition, children, ...props }) => {
    if (condition) {
        return <>{children}</>
    } else {
        return <></>
    }
}


interface XScrollWrapperProps {
    children: React.ReactNode;
    className?: string;
}

export const XScrollWrapper:FC<XScrollWrapperProps> = ({ children, className='', ...props }) => {
    return (
        <div className={`x-scroll ${className !== '' ? className : ''}`}>
            { children }
        </div>
    )
}


interface FlexWrapperProps {
    children: React.ReactNode;
    justifyContent?: 'space-between'| 'space-around' | 'flex-start' | 'flex-end' | 'center';
    alignItems?: 'stretch' | 'center' | 'start' | 'end';
    flexDirection?: 'column' | 'column-reverse' | 'row' | 'row-reverse';
    flexWrap?: "nowrap" |  "wrap-reverse" | "wrap"
    className?: string;
    style?: CSSProperties;
}


export const FlexWrapper:FC<FlexWrapperProps> = ({ 
    children, 
    justifyContent='space-between', 
    alignItems='center', 
    flexDirection='row', 
    className='', 
    flexWrap = 'wrap',
    ...props 
}) => {
    return (
        <div 
            className={`relative flex ${className}`} 
            style={
                {
                    justifyContent: justifyContent, 
                    alignItems:alignItems, 
                    flexDirection: flexDirection,
                    flexWrap: flexWrap,
                }
            }>
            { children }
        </div>
    )
}


interface GridWrapperWrops {
    children: React.ReactNode;
    gridTemplateColumns?: string;
    className?: string; 
}


export const GridWrapper:FC<GridWrapperWrops> = ({ children, className='', gridTemplateColumns = "1fr 1fr", ...props }) => {
    return (
        <div 
            className={`${className}`} 
            style={
                {
                    display: 'grid',
                    gridTemplateColumns: gridTemplateColumns,
                    gap: '0.5rem',
                    alignItems: "baseline"
                }
            }>
            { children }
        </div>
    )
}